import { render, staticRenderFns } from "./batchImportPolicyInfo.vue?vue&type=template&id=33145bc1&scoped=true"
import script from "./batchImportPolicyInfo.vue?vue&type=script&lang=js"
export * from "./batchImportPolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./batchImportPolicyInfo.vue?vue&type=style&index=0&id=33145bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33145bc1",
  null
  
)

export default component.exports